import script from "./Delay-Management.vue?vue&type=script&setup=true&lang=js"
export * from "./Delay-Management.vue?vue&type=script&setup=true&lang=js"

import "./Delay-Management.vue?vue&type=style&index=0&id=3326ce1a&scoped=true&lang=css"

import exportComponent from "/Users/Joe/Documents/Projects/MCR-WebFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3326ce1a"]])

export default __exports__